var _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function Svg404Illustration(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 176,
    height: 176,
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("rect", {
    id: "a",
    x: 0,
    y: 0,
    width: 176,
    height: 176,
    rx: 88
  }), /*#__PURE__*/React.createElement("rect", {
    id: "e",
    x: 142,
    y: 211,
    width: 118,
    height: 118,
    rx: 4
  }), /*#__PURE__*/React.createElement("rect", {
    id: "h",
    x: 142,
    y: 69,
    width: 118,
    height: 118,
    rx: 4
  }), /*#__PURE__*/React.createElement("rect", {
    id: "j",
    x: 0,
    y: 0,
    width: 118,
    height: 118,
    rx: 4
  }), /*#__PURE__*/React.createElement("rect", {
    id: "l",
    x: 0,
    y: 142,
    width: 118,
    height: 148,
    rx: 4
  }), /*#__PURE__*/React.createElement("linearGradient", {
    x1: "50%",
    y1: "0%",
    x2: "50%",
    y2: "100%",
    id: "b"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F3F5F9",
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E2E8F0",
    offset: "100%"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    x1: "50%",
    y1: "100%",
    x2: "50%",
    y2: "30.355%",
    id: "f"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F8FAFC",
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFF",
    offset: "100%"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    x1: "50%",
    y1: "0%",
    x2: "50%",
    y2: "100%",
    id: "m"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#A5B4FC",
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#818CF8",
    offset: "100%"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    x1: "50%",
    y1: "7.522%",
    x2: "50%",
    y2: "100%",
    id: "n"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#4338CA",
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#6366F1",
    stopOpacity: 0,
    offset: "100%"
  })), /*#__PURE__*/React.createElement("filter", {
    x: "-5.9%",
    y: "-4.2%",
    width: "111.9%",
    height: "111.9%",
    filterUnits: "objectBoundingBox",
    id: "d"
  }, /*#__PURE__*/React.createElement("feOffset", {
    dy: 2,
    in: "SourceAlpha",
    result: "shadowOffsetOuter1"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2,
    in: "shadowOffsetOuter1",
    result: "shadowBlurOuter1"
  }), /*#__PURE__*/React.createElement("feComposite", {
    in: "shadowBlurOuter1",
    in2: "SourceAlpha",
    operator: "out",
    result: "shadowBlurOuter1"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 0.0588235294 0 0 0 0 0.0901960784 0 0 0 0 0.164705882 0 0 0 0.06 0",
    in: "shadowBlurOuter1"
  })), /*#__PURE__*/React.createElement("filter", {
    x: "-5.9%",
    y: "-4.2%",
    width: "111.9%",
    height: "111.9%",
    filterUnits: "objectBoundingBox",
    id: "g"
  }, /*#__PURE__*/React.createElement("feOffset", {
    dy: 2,
    in: "SourceAlpha",
    result: "shadowOffsetOuter1"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2,
    in: "shadowOffsetOuter1",
    result: "shadowBlurOuter1"
  }), /*#__PURE__*/React.createElement("feComposite", {
    in: "shadowBlurOuter1",
    in2: "SourceAlpha",
    operator: "out",
    result: "shadowBlurOuter1"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 0.0588235294 0 0 0 0 0.0901960784 0 0 0 0 0.164705882 0 0 0 0.06 0",
    in: "shadowBlurOuter1"
  })), /*#__PURE__*/React.createElement("filter", {
    x: "-5.9%",
    y: "-4.2%",
    width: "111.9%",
    height: "111.9%",
    filterUnits: "objectBoundingBox",
    id: "i"
  }, /*#__PURE__*/React.createElement("feOffset", {
    dy: 2,
    in: "SourceAlpha",
    result: "shadowOffsetOuter1"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2,
    in: "shadowOffsetOuter1",
    result: "shadowBlurOuter1"
  }), /*#__PURE__*/React.createElement("feComposite", {
    in: "shadowBlurOuter1",
    in2: "SourceAlpha",
    operator: "out",
    result: "shadowBlurOuter1"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 0.0588235294 0 0 0 0 0.0901960784 0 0 0 0 0.164705882 0 0 0 0.06 0",
    in: "shadowBlurOuter1"
  })), /*#__PURE__*/React.createElement("filter", {
    x: "-5.9%",
    y: "-3.4%",
    width: "111.9%",
    height: "109.5%",
    filterUnits: "objectBoundingBox",
    id: "k"
  }, /*#__PURE__*/React.createElement("feOffset", {
    dy: 2,
    in: "SourceAlpha",
    result: "shadowOffsetOuter1"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2,
    in: "shadowOffsetOuter1",
    result: "shadowBlurOuter1"
  }), /*#__PURE__*/React.createElement("feComposite", {
    in: "shadowBlurOuter1",
    in2: "SourceAlpha",
    operator: "out",
    result: "shadowBlurOuter1"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 0.0588235294 0 0 0 0 0.0901960784 0 0 0 0 0.164705882 0 0 0 0.06 0",
    in: "shadowBlurOuter1"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "c",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#a"
  })), /*#__PURE__*/React.createElement("use", {
    fill: "url(#b)",
    xlinkHref: "#a"
  }), /*#__PURE__*/React.createElement("g", {
    mask: "url(#c)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "rotate(-20 -150.722 164.706)"
  }, /*#__PURE__*/React.createElement("use", {
    fill: "#000",
    filter: "url(#d)",
    xlinkHref: "#e"
  }), /*#__PURE__*/React.createElement("rect", {
    strokeOpacity: 0.8,
    stroke: "#CBD5E1",
    strokeLinejoin: "square",
    fill: "url(#f)",
    x: 142.5,
    y: 211.5,
    width: 117,
    height: 117,
    rx: 4
  })), /*#__PURE__*/React.createElement("g", {
    transform: "rotate(-20 -150.722 164.706)"
  }, /*#__PURE__*/React.createElement("use", {
    fill: "#000",
    filter: "url(#g)",
    xlinkHref: "#h"
  }), /*#__PURE__*/React.createElement("rect", {
    strokeOpacity: 0.8,
    stroke: "#CBD5E1",
    strokeLinejoin: "square",
    fill: "url(#f)",
    x: 142.5,
    y: 69.5,
    width: 117,
    height: 117,
    rx: 4
  })), /*#__PURE__*/React.createElement("g", {
    transform: "rotate(-20 -150.722 164.706)"
  }, /*#__PURE__*/React.createElement("use", {
    fill: "#000",
    filter: "url(#i)",
    xlinkHref: "#j"
  }), /*#__PURE__*/React.createElement("rect", {
    strokeOpacity: 0.8,
    stroke: "#CBD5E1",
    strokeLinejoin: "square",
    fill: "url(#f)",
    x: 0.5,
    y: 0.5,
    width: 117,
    height: 117,
    rx: 4
  })), /*#__PURE__*/React.createElement("g", {
    transform: "rotate(-20 -150.722 164.706)"
  }, /*#__PURE__*/React.createElement("use", {
    fill: "#000",
    filter: "url(#k)",
    xlinkHref: "#l"
  }), /*#__PURE__*/React.createElement("rect", {
    strokeOpacity: 0.8,
    stroke: "#CBD5E1",
    strokeLinejoin: "square",
    fill: "url(#f)",
    x: 0.5,
    y: 142.5,
    width: 117,
    height: 147,
    rx: 4
  }))), /*#__PURE__*/React.createElement("g", {
    mask: "url(#c)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "url(#m)",
    d: "M43.103 0l42.97 86.267-42.97-13.48L.132 86.267z",
    transform: "rotate(-51 93.327 26.607)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#n)",
    d: "M85.694 85.504h-2.052l-40.54-12.717-.445.14V.895L43.103 0z",
    transform: "rotate(-51 93.327 26.607)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M115.34 104.24c10.516 7.682 22.413 13.456 34.883 17.051.683.203.858-.412.185-.628-6.138-1.912-11.97-4.83-17.498-8.092-5.542-3.269-10.787-6.87-16.107-10.326-2.145-1.415-3.683.349-1.463 1.995M113.053 118.196c19.255 21.87 38.637 43.728 57.93 65.59 1.058 1.199 1.536.775.49-.433-18.992-21.94-36.863-45.466-56.567-66.794-4-4.33-5.926-2.988-1.853 1.637",
    fillOpacity: 0.4,
    fill: "#475569"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(Svg404Illustration);
export default __webpack_public_path__ + "static/media/404-illustration.ee4d58f7a1e3ed4cd51a38270540e0af.svg";
export { ForwardRef as ReactComponent };